import { createMuiTheme } from '@material-ui/core/styles';
import consts from '../../main/consts';

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
    body1: {
      color: '#757575',
    },
    body2: {
      color: '#757575',
    },
    h4: {
      color: '#757575',
    },
  },
  palette: {
    primary: {
      light: '#f44336',
      main: '#F80032',
      dark: '#212121',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ffffff',
      main: '#F80032',
      dark: '#d32f2f',
      contrastText: '#fff',
    },
    pages: {
      'dashboard': '#757575',
      'edited': consts.EDIT_IMMEDIATELY ? '#00CBFF' : '#12CD0B',
      'new-orders': '#12CD0B',
      'estimated': '#091582',
      'new-orders-criado': '#12CD0B',
      'new-orders-incluido': '#12CD0B',
      'new-orders-visualizado': '#12CD0B',
      'picking': '#00CBFF',
      'in-edition': '#00CBFF',
      'ready-to-go': '#FFAA00',
      'shipping': '#CE00FF',
      'returning-to-storage': '#B72F2C',
      'history': '#757575',
      'paid': '#12CD0B',
      'invoice': '#12CD0B',
      'concluded': '#0D9A5D',
      'canceled': '#B71C1C',
      'canceled-from-store': '#B71C1C',
      'returned': '#B71C1C',
      'recused': '#B71C1C',
      'withdrawn': '#0D9A5D',
      'delivered': '#0D9A5D',
      'confirmed-change': '#00CBFF',
      'pendency': '#FFDF9F',
      'without-pendency': '#FFDF9F',
    },
  },
});

export default theme;
